import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.75 13.8001C16.75 13.3859 16.4142 13.0501 16 13.0501C15.5858 13.0501 15.25 13.3859 15.25 13.8001C15.25 15.595 13.7949 17.0501 12 17.0501C11.5858 17.0501 11.25 17.3859 11.25 17.8001C11.25 18.2143 11.5858 18.5501 12 18.5501C14.6234 18.5501 16.75 16.4234 16.75 13.8001Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4586 1.97068C11.4036 2.01379 11.3245 2.07666 11.2248 2.15815C11.0253 2.32109 10.7428 2.55884 10.4049 2.8625C9.73018 3.46891 8.82943 4.34279 7.92674 5.41284C6.14433 7.5257 4.25 10.5257 4.25 13.8077C4.25 18.0879 7.71979 21.5577 12 21.5577C16.2802 21.5577 19.75 18.0879 19.75 13.8077C19.75 10.5257 17.8557 7.5257 16.0733 5.41284C15.1706 4.34279 14.2698 3.46891 13.5951 2.8625C13.2572 2.55884 12.9747 2.32109 12.7752 2.15815C12.6755 2.07666 12.5964 2.01379 12.5414 1.97068C12.2087 1.70981 11.7913 1.7098 11.4586 1.97068ZM11.4076 3.97814C10.7698 4.55132 9.92057 5.37564 9.07326 6.38004C7.35567 8.41607 5.75 11.0699 5.75 13.8077C5.75 17.2595 8.54822 20.0577 12 20.0577C15.4518 20.0577 18.25 17.2595 18.25 13.8077C18.25 11.0699 16.6443 8.41607 14.9267 6.38004C14.0794 5.37564 13.2302 4.55132 12.5924 3.97814C12.0147 3.45894 11.9853 3.45894 11.4076 3.97814Z",
		fill: "currentColor"
	})]
});
export { SvgIconColor as ReactComponent };
